import { combineReducers } from "redux";
import { collections } from "./shared/collections";
import items from "./shared/items";
import ExclusionsConstants from "../constants/ExclusionsConstants";

export default combineReducers({
    collections: collections(ExclusionsConstants.ACTION_TYPE_IDENTIFIER),
    items: items(ExclusionsConstants.ACTION_TYPE_IDENTIFIER)
});
